import type { ReactNode } from 'react';
import styled from 'styled-components';
import { formatSellerType } from 'helpers/formatting';
import {
  Content,
  InfoTitle,
  InfoTitleProps,
} from 'components/Toolkit/InfoTitle/InfoTitle';
import { media } from 'helpers/breakpoints';

export interface MiniUserProfileProps extends InfoTitleProps {
  county?: string;
  type?: string;
  franchiseType?: string;
  isTrader: boolean;
  verification?: { email?: boolean; phone?: boolean; bank?: boolean };
  isDealer?: boolean;
  className?: string;
  largeTruncationWidth?: number;
  position?: 'MAIN' | 'SIDE';
  subtitleComponent?: ReactNode;
  renderAdditionalHeaderInfo?: ReactNode;
}

const SInfoTitle = styled(InfoTitle)`
  ${Content} {
    ${media.smallOnly} {
      max-width: 184px;
    }
  }
`;

function MiniUserProfile({
  title,
  illustration,
  county,
  type,
  franchiseType,
  isTrader,
  verification,
  isDealer = false,
  className,
  largeTruncationWidth,
  position = 'MAIN',
  subtitleComponent,
  renderAdditionalHeaderInfo,
}: MiniUserProfileProps) {
  return (
    <div className={className}>
      <SInfoTitle
        title={title}
        illustration={illustration}
        listItems={
          subtitleComponent
            ? [subtitleComponent]
            : isDealer
            ? position === 'MAIN'
              ? [franchiseType]
              : [county]
            : [county, formatSellerType(isTrader, verification, type)]
        }
        shouldTruncate={true}
        largeTruncationWidth={largeTruncationWidth}
      />
      {renderAdditionalHeaderInfo && <>{renderAdditionalHeaderInfo}</>}
    </div>
  );
}

export { MiniUserProfile };
